<template>
    <div>
      <div class="box box-primary" style="width:100%">
      <div class="box-header with-border">
        <div
          style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
        >
          <b>{{$t('sidebar.propertymanagement.facilities_management')}}</b>
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="addNewAsset"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-plus"></i>
            </span>
            {{$t('customer.addnew')}}
          </button>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-12 table-responsive no-padding">
              <b-table :items="apartmentAssetDataList" :fields="apartmentAssetDataFields" class="mt-3" outlined>
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template slot="target" slot-scope="row">
                  <a :href="row.item.url" target="_blank" :id="`apartment_reservation_target_${row.item.id}`">{{row.item.target}}</a>
                  <tooltip :text="row.item.url" :target="`#apartment_reservation_target_${row.item.id}`"/>
                </template>
                 <template slot="property.asset.asset_status" slot-scope="row">
                  <b-form-select
                    style="width:200px"
                    :options="assetStatus"
                    v-model="asset_status"
                    @change="updatedStatus(row.item)"
                    class="form-control"
                  />
                  
                </template>

                <template slot="actions" slot-scope="row">
                  <template>
                    <div class="btn-group">
                      <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu hide-scroll-bar" style="min-width: 50px;max-height: 80px;">
                          <li><button
                          class="btn btn-info btn-sm"
                          style="margin-left: 6px;"
                          @click="editApartmentAsset(row)"
                        >
                          <i class="glyphicon glyphicon-edit"></i>
                        </button></li>
                      </ul>
                  </div>
                  </template>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from "@/lib/utils";
export default {
  name: "ApartmentAssets",
  props: {
    apartment_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    apartment_code: {
      type: String,
      default: () => {
        return 0;
      }
    },
    apartment_from: {
      type: String,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      dateOptions: {
        format: "DD-MM-YYYY hh:mm a"
      },
      assetStatus:[],
      asset_status: 1,
      apartmentAssetDataList: [],
      apartmentAssetDataFields: [
        { key: 'common.code', label: "common.code", sortable: true, class: 'text-center' },
        { key: 'property.asset.name', label: 'property.asset.name', sortable: true, class: 'text-center' },
        { key: "property.asset.type", label: "property.asset.type", sortable: true, class: 'text-center' },
        { key: "invoice.einvoice.measure", label: "invoice.einvoice.measure", sortable: true, class: 'text-center' },
        { key: 'invoice.einvoice.quantity', label: "invoice.einvoice.quantity", sortable: true, class: 'text-center' },
        { key: "property.asset.unit_price", label: "property.asset.unit_price", sortable: true, class: 'text-center' },
        { key: 'property.asset.total_fee', label: "property.asset.total_fee", sortable: true, class: 'text-center' },
        { key: 'property.asset.of_the_apartment', label: "property.asset.of_the_apartment", sortable: true, class: 'text-center' },
        { key: 'property.asset.installed_date', label: 'property.asset.installed_date', sortable: true, class: 'text-center' },
        { key: "property.asset.maintainance_start_date", label: "property.asset.maintainance_start_date", sortable: true, class: 'text-center' },
        { key: 'property.asset.maintainance_expired_date', label: 'property.asset.maintainance_expired_date', sortable: true, class: 'text-center'},
        { key: 'property.asset.maintainance_required_date', label: 'property.asset.maintainance_required_date', sortable: true, class: 'text-center'},
        { key: 'property.asset.location', label: "property.asset.location", sortable: true, class: 'text-center' },
        { key: "property.asset.other_details", label: "property.asset.other_details", sortable: true, class: 'text-center' },
        { key: "property.asset.asset_status", label: "property.asset.asset_status", stortable: true, class:'text-center'},
        { key: "actions", label: "common.action", sortable: true, class: 'text-center' }
      ],
    }
  },
  watch: {
    GET_ASSET_DATA: function() {
      this.apartmentAssetDataList = [];
      this.GET_ASSET_DATA.forEach((asset, i) => {
        let code = asset.code;
        let name = asset.name;
        // let type = asset.type;
        let type_name = asset.type_name;
        let location = asset.location;
        let installed_date = utils.formatSqlDate(asset.installed_date, null, this.dateOptions.format);
        let maintainance_start_date = utils.formatSqlDate(asset.maintainance_start_date, null, this.dateOptions.format);
        let maintainance_expired_date = utils.formatSqlDate(asset.maintainance_expired_date, null, this.dateOptions.format);
        let maintainance_required_date = utils.formatSqlDate(asset.maintainance_required_date, null, this.dateOptions.format);
        let asset_status = asset.asset_status
        this.asset_status = asset_status
        let data = {
          'asset.id': asset.id,
          "common.code": code,
          'property.asset.of_the_apartment': !utils.isNull(asset.apartment) ? asset.apartment.apartment_code : 'Tài Sản Chung',
          "property.asset.name": name,
          "property.asset.type": type_name,
          "property.asset.location": location,
          "property.asset.installed_date": installed_date,
          "property.asset.maintainance_start_date": maintainance_start_date,
          "property.asset.maintainance_expired_date": maintainance_expired_date,
          "property.asset.maintainance_required_date": maintainance_required_date,
          'property.asset.unit_price': !utils.isNull(asset.price) && utils.formatNumber(asset.price),
          "property.asset.total_fee": !utils.isNull(asset.total) && utils.formatNumber(asset.total),
          "property.asset.other_details": asset.other_details,
          "invoice.einvoice.quantity": asset.quantity,
          "invoice.einvoice.measure": !utils.isNull(asset.unit) ? (asset.unit == 1 ? this.$t('property.asset.unit_measure') : this.$t('property.asset.set_measure')) : '',
          "property.asset.asset_status" : this.asset_status
        };
        this.apartmentAssetDataList.push(data);
      });
    },
  },
  computed: {
    ...mapGetters([
      "GET_ASSET_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_ASSET_LIST",
      "GET_ASSET_STATUS_LIST",
      "UPDATE_ASSET_STATUS"
    ]),
    updatedStatus: function(event){
      let data = {
        asset_status: this.asset_status,
        id: event['asset.id'],
      };
      this.UPDATE_ASSET_STATUS(data).then(
        function() {
              this.SUCCESS_TOAST();
            }.bind(this)
      ).catch(
            function() {
              this.ERROR_TOAST();
            }.bind(this)
          );
    },

    editApartmentAsset: function(apartmentAssetItem) {
      let asset_id = apartmentAssetItem.item['asset.id']
      this.$router.push({
        name: "AssetAdd",
        params: {
          fromApartmentAsset: "fromApartmentAsset",
          id: asset_id,
          apartment_id: this.$route.params.id,
          apartment_code: this.apartment_code,
          apartment_from: this.apartment_from,
        }
      });
    },
    addNewAsset: function() {
      this.$router.push({
        name: "AssetAdd",
        params: {
          fromApartmentAsset: "fromApartmentAsset",
          id: 0,
          apartment_id: this.$route.params.id,
          apartment_code: this.apartment_code,
          apartment_from: this.apartment_from,
        }
      });
    }
  },
  components: {
  },
  mounted() {
    const data = {
      params: {
        page: null,
        isGetApartmentAsset: 'True',
        apartment_id: this.$route.params.id
      }
    };
    this.GET_ASSET_LIST(data)
    this.GET_ASSET_STATUS_LIST().then(
      function(res) {
        let assetStatusList = res.data
        let assetStatus = []
        assetStatusList.forEach(data=>{
          let item = {
            value: data.id,
            text: data.name
          }
          assetStatus.push(item)
        })
        this.assetStatus = assetStatus
      }.bind(this)
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/ApartmentAssets.vue